import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { AwardsService } from '../services';
import { awardsKeys } from '../queryKeys';
import { DEFAULT_PAGE_SIZE, clampPage } from '../pagination';

/**
 * One user's cycle history for the profile Promotion tab: every cycle,
 * newest-created first, crossed with the user's status in it.
 */
export const useGetUserCycles = (userId, page = 1) => {
  const safePage = clampPage(page);

  const { data, error, isError, isPending, isFetching } = useQuery({
    queryKey: awardsKeys.userCycles(userId, safePage),
    queryFn: () => AwardsService.getUserCycles(userId, safePage),
    enabled: Boolean(userId),
    retry: false,
    placeholderData: keepPreviousData,
  });

  return {
    userCycles: data?.items ?? [],
    page: data?.page ?? safePage,
    pageSize: data?.pageSize ?? DEFAULT_PAGE_SIZE,
    totalCount: data?.totalCount ?? 0,
    isPending,
    isFetching,
    isError,
    error,
  };
};
